import { render } from "./App.vue?vue&type=template&id=c0a006a6&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@ma/basic-styles/dist/basic-styles.css?vue&type=style&index=0&lang=css"
import "./App.vue?vue&type=style&index=1&id=c0a006a6&scoped=true&lang=css"

import exportComponent from "/app/Reifenlager_Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0a006a6"]])

export default __exports__